module.exports = __webpack_public_path__ + "img/bg_stage1.af2705c4.png";